import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import styles from "./AddBattery.module.scss";
import {
  getRequestInService as getRequest,
  postRequestInService as postRequest,
  putRequestInService as putRequest,
} from "services/axiosServiceBaseClient";
import { useHistory } from "react-router-dom";
import { decryptWithAES } from "components/common/encyptDecrypt";
import { getRequestInAssets as getRequestOnEnterprise } from "services/axiosAssetsBaseClient";

import Master from "../Master";
import notificationService from "services/notification.service";
import LocalStorageService from "services/tokenlocalstorage.service";
import jwtDecode from "jwt-decode";
import tokenlocalstorageService from "services/tokenlocalstorage.service";
import Select from "react-select";

var emailId = undefined;
var action = "Submit";
var title = "Add Operator";
var view = undefined;
var onlyView = false;
var id = undefined;

function AddOperatorForm(props) {
  if (props.match.params.email !== undefined) {
    emailId = decryptWithAES(props.match.params.email);
  }
  view = props?.match?.params?.view;
  id = props?.match?.params?.id;

  const initialFormValues = {
    enterpriseName: "",
    zipCode: "",
    country: "",
    countryId: -1,
    state: "",
    stateId: -1,
    city: "",
    cityId: -1,
    addressLine1: "",
    addressLine2: "",
    username: "",
    emailId: "",
    phoneNumber: "",
    isActive: true,
    // firstName: "",
    // lastName: "",
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [updateCountry, setUpdateCountry] = useState("");
  const [updateState, setUpdateState] = useState("");
  const [updateCity, setUpdateCity] = useState("");
  const [siteName, setSiteName] = useState([]);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);

  const getUserDetail = useCallback(async () => {
    const token = tokenlocalstorageService.getLocalAccessToken();
    // console.log(token, 'TOKEN')
    var decode = jwtDecode(token);

    // setUserEmail(decode.email)
    const userRole = LocalStorageService.get("user-role");
    let currentRole = "";
    let email = "";
    email = decode.email;
    userRole.toLocaleLowerCase() === "admin"
      ? (currentRole = "admin")
      : (currentRole = "operator");
    // console.log(currentRole,email,"Email","currentRole")
    await getRequest("bss/svc/" + currentRole+"/info" )
      .then((res) => {
        if (res && res?.data) {
          if (title == "Add Operator") {
            getSiteName(res.data.enterpriseName);
            setFormValues({
              ...formValues,
              enterpriseName: res.data.enterpriseName,
            });
          }
        }
      })
      .catch((error) => {
        notificationService.showNonBlacklistedError(
          error?.config?.url,
          error?.response?.message
        );
        return error;
      });
  }, []);

  useEffect(() => {
    getUserDetail();
  }, []);

  const getSiteName = useCallback(async (enterpriseName) => {
    await getRequestOnEnterprise("bss/siteInfo?enterprise=" + enterpriseName)
      .then((res) => {
        if (res && res?.data) {
          setSiteName(res?.data?.sites);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getCountryList = useCallback(async (string) => {
    await getRequestOnEnterprise("getCountries")
      .then((res) => {
        if (res.data != null) {
          setCountry(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getStateList = useCallback(async (string) => {
    await getRequestOnEnterprise(`getStates?countryId=${string}`)
      .then((res) => {
        if (res.data != null) {
          setState(res?.data);
        }
        if (res.data.length == 0) {
          setCity([]);
          setFormValues((data) => ({
            ...data,
            stateId: -1,
            countryId: -1,
            cityId: -1,
          }));
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getCitList = useCallback(async (stateId) => {
    await getRequestOnEnterprise(`getCities?stateId=${stateId}`)
      .then((res) => {
        if (res.data != null) {
          setCity(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getCountryList();
  }, [getCountryList]);

  const getOperatorDataByEmailID = useCallback(async (id) => {
    await getRequest("bss/svc/operator?id=" + id)
      .then((res) => {
        if (res.data != null) {
          patchForm(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    onlyView = false;
    if (id !== undefined && view == undefined) {
      action = "Update";
      title = "Update Operator";
      onlyView = false;
      getOperatorDataByEmailID(id);
    } else if (id !== undefined && view !== undefined) {
      action = "View";
      title = "View Operator";
      onlyView = true;
      getOperatorDataByEmailID(id);
    } else {
      action = "Submit";
      title = "Add Operator";
    }
  }, []);

  const patchForm = (data) => {
    if (data?.enterpriseName) {
      getSiteName(data.enterpriseName);
    }
    if (data?.countryId) {
      setUpdateCountry(data.country);
      getStateList(data?.countryId);
    }
    if (data?.stateId) {
      setUpdateState(data.state);
      setUpdateCity(data.city);
      getCitList(data?.stateId);
    }

    for (var i = 0; i < data.siteId.length; i++) {
      var datatemp = {};
      datatemp.value = data.siteId[i];
      for (var j = 0; j <= i; j++) {
        datatemp.label = data.siteName[i];
      }
      selected.push(datatemp);
    }

    // const fullName = data?.username.split(" ");
    setFormValues({
      ...formValues,
      id: data.id,
      enterpriseName: data.enterpriseName,
      zipCode: data.zipCode,
      country: data.country,
      countryId: data.countryId,
      state: data.state,
      stateId: data.stateId,
      city: data.city,
      cityId: data.cityId,
      addressLine1: data.addressLine1,
      addressLine2: data.addressLine2,
      // firstName: fullName[0],
      // lastName: fullName[1],
      username: data.username,
      emailId: data.emailId,
      phoneNumber: data.phoneNumber,
      isActive: data.isActive,
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    if (name === "countryId") {
      getStateList(value);
      country.find((info) => {
        if (info.id == value) {
          setUpdateCountry(info.name);
        }
      });
    }

    if (name === "stateId") {
      getCitList(value);
      setUpdateCity("");
      setFormValues({ ...formValues, stateId: value, cityId: -1 });
      state.find((info) => {
        if (info.id == value) {
          setUpdateState(info.name);
        }
      });
    }
    if (name === "cityId") {
      city.find((info) => {
        if (info.id == value) {
          setUpdateCity(info.name);
        }
      });
    }
    if (name === "zipCode") {
      setFormValues({ ...formValues, [name]: value.replace(/\D/g, "") });
    }
    if (name === "phoneNumber") {
      setFormValues({ ...formValues, [name]: value.replace(/\D/g, "") });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let result = validate(formValues);

    if (
      Object.values(result).every((x) => {
        return x === "";
      })
    ) {
      if (action === "Submit") {
        try {
          const payload = {
            enterpriseName: formValues?.enterpriseName,
            zipCode: formValues?.zipCode,
            country: updateCountry,
            countryId: formValues.countryId,
            state: updateState,
            stateId: formValues.stateId,
            city: updateCity,
            cityId: formValues.cityId,
            addressLine1: formValues?.addressLine1,
            addressLine2: formValues?.addressLine2,
            username: formValues?.username,
            // formValues?.firstName?.trim() +
            // (formValues?.lastName ? " " + formValues?.lastName.trim() : ""),
            emailId: formValues?.emailId,
            emailId: formValues?.emailId,
            phoneNumber: formValues?.phoneNumber,
            isActive: formValues?.isActive,
            siteId: formValues.siteId,
            siteName: formValues.sitesName,
          };
          postRequest("bss/svc/operator/add", payload)
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Users",
                  state: { table: 1 },
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
              }
            })
            .catch((error) => {
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
              return error;
            });
        } catch (error) {
          console.log(error);
        }
      }
      if (action === "Update") {
        country.find((info) => {
          if (info.id == formValues.countryId) {
            formValues.country = info.name;
          }
        });
        let newSiteIds = [];
        let newSiteName = [];
        for (let i = 0; i < selected?.length; i++) {
          newSiteIds.push(selected[i]?.value);
          newSiteName.push(selected[i]?.label);
        }
        const payload = {
          enterpriseName: formValues?.enterpriseName,
          zipCode: formValues?.zipCode,
          country: updateCountry,
          countryId: formValues.countryId,
          state: updateState,
          stateId: formValues.stateId,
          city: updateCity,
          cityId: formValues.cityId,
          addressLine1: formValues?.addressLine1,
          addressLine2: formValues?.addressLine2,
          username: formValues?.username,
          // formValues?.firstName?.trim() +
          // (formValues?.lastName ? " " + formValues?.lastName.trim() : ""),
          emailId: formValues?.emailId,
          phoneNumber: formValues?.phoneNumber,
          isActive: formValues?.isActive,
          id: Number(id),
          siteId: newSiteIds,
          siteName: newSiteName,
        };
        try {
          putRequest("bss/svc/operator/update", JSON.stringify(payload))
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Users",
                  state: { table: 1, compomentRenderType: "view" },
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
              }
            })
            .catch((error) => {
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
              return error;
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const validate = (formValues) => {
    const errors = {};

    if (!formValues.enterpriseName || formValues.enterpriseName === "0") {
      errors.enterpriseName = "Enterprise name is required!";
    } else {
      errors.enterpriseName = "";
    }

    if (!/^[ A-Za-z0-9-_./&']*$/i.test(formValues.username)) {
      errors.username = "/-_&. are the only allowed special characters!";
    } else if (formValues.username.trim() === "") {
      errors.username = "Name is required!";
    } else {
      errors.username = "";
    }

    // if (!/^[ A-Za-z0-9-_./&']*$/i.test(formValues.lastName)) {
    //   errors.lastName = "/-_&. are the only allowed special characters!";
    // }

    // else if (formValues.firstName.trim() === "") {
    //   errors.lastName = "Last name is required!";
    // }
    // else {
    //   errors.lastName = "";
    // }

    if (!formValues.phoneNumber) {
      errors.phoneNumber = "Phone number is required!";
    } else if (formValues.phoneNumber.length !== 10) {
      errors.phoneNumber =
        "This is not a valid contact number, required 10 digits";
    }
    //  else if (!/^[0-9]+$/i.test(formValues.phoneNumber)) {
    //   errors.phoneNumber = "This is not a valid phone number";
    // }
    else {
      errors.phoneNumber = "";
    }

    if (!formValues.emailId) {
      errors.emailId = "Email id is required!";
    } else if (
      !/^([\w.-]+@([\w-]+\.)+[\w-]{2,4})?$/i.test(formValues.emailId)
    ) {
      errors.emailId = "This is not a valid emailId format!";
    } else {
      errors.emailId = "";
    }
    if (!formValues.addressLine1) {
      errors.addressLine1 = "Address Line 1 is required!";
    } else if (!/^[ A-Za-z0-9_./#@&+\-,]*$/i.test(formValues.addressLine1)) {
      errors.addressLine1 =
        "Only Accept alphanumeric and some special character .&#@/,-";
    } else if (formValues.addressLine1.trim() === "") {
      errors.addressLine1 = "This is not a valid address";
    } else {
      errors.addressLine1 = "";
    }

    if (selected.length <= 0) {
      errors.siteNames = "Site Name is required!";
    } else {
      errors.siteNames = "";
    }

    if (!/^[ A-Za-z0-9_./#@&+\-,]*$/i.test(formValues.addressLine2)) {
      errors.addressLine2 =
        "Only Accept alphanumeric and some special character .&#@/,-";
    }

    if (formValues.countryId == -1) {
      errors.country = "Country is required!";
    } else {
      errors.country = "";
    }

    if (formValues.cityId == -1) {
      errors.city = "City is required!";
    } else {
      errors.city = "";
    }

    if (formValues.stateId == -1) {
      errors.state = "State is required!";
    } else {
      errors.state = "";
    }

    if (!formValues.zipCode) {
      errors.zipCode = "Zip code is required!";
    } else if (formValues.zipCode.length !== 6) {
      errors.zipCode = "This is not a valid zip code, required 6 digits";
    }
    // else if (!/^[0-9]+$/i.test(formValues.zipCode)) {
    //   errors.zipCode = "This is not a valid zip code";
    // }
    else {
      errors.zipCode = "";
    }
    if (formValues.isActive == -1) {
      errors.isActive = "Status is required!";
    } else {
      errors.isActive = "";
    }

    setFormErrors(errors);
    return errors;
  };

  const history = useHistory();

  const reset = () => {
    history.push({
      pathname: "/Users",
      state: { table: 1, compomentRenderType: "view" },
    });
  };

  const handleSelectChange = (e) => {
    const nameValue = e.target.value.split("-:-");
    setFormValues({ ...formValues, [nameValue[0]]: nameValue[1] });
  };

  const handleMultiSelectChange = (e) => {
    setSelected(e);

    let newSiteIds = [];
    let newSiteName = [];
    for (let i = 0; i < e?.length; i++) {
      newSiteIds.push(e[i]?.value);
      newSiteName.push(e[i]?.label);
    }
    setFormValues({
      ...formValues,
      ["siteId"]: newSiteIds,
      ["sitesName"]: newSiteName,
    });
    // setFormValues({ ...formValues, ["sitesName"]: newSiteName });
  };
  const options1 = [];

  siteName?.map((item) => {
    options1.push({ label: item?.siteName, value: item?.siteId });
  });
  useEffect(() => {
    if (options1.length > 0) {
      setOptions(options1);
    }
  }, [siteName]);

  return (
    <>
      <h2
        id="AddOperator_Heading"
        className={cn(styles.medium_title, styles.medium_title_layout)}
      >
        Operator
      </h2>

      <div
        id="AddOperator_Form_layout"
        className={cn(styles.group, styles.group_layout)}
      >
        <form id="AddOperator_Form">
          <div
            id="AddOperator_Form_layout1"
            className={cn(styles.flex3, styles.flex3_layout)}
          >
            <h3
              id="AddOperator_Form_title"
              className={cn(styles.subtitle, styles.subtitle_layout)}
            >
              {title}
            </h3>
            <hr className={cn(styles.line, styles.line_layout)} />

            <div
              id="AddOperator_Form_row1"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddOperator_EnterpriseName_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_EnterpriseName"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_EnterpriseName_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Enterprise Name*"}
                  </div>
                  <input
                    id="AddOperator_EnterpriseName_input"
                    type="text"
                    name="enterpriseName"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.enterpriseName}
                    onChange={handleChange}
                    disabled={true}
                  />
                </div>
                <p>{formErrors.enterpriseName}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddOperator_SiteName_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_SiteName"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_SiteName_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Site Name*"}
                  </div>
                  <Select
                    id="AddOperator_SiteName_select"
                    options={options1}
                    placeholder="Select"
                    value={selected}
                    onChange={handleMultiSelectChange}
                    isSearchable={true}
                    isMulti
                    isCheckbox
                    //isOptions1Disabled={(options1) => options1.disabled}  ...defaultStyles,
                    isDisabled={onlyView}
                    // styles={{
                    //   // indicatorSeparator: () => {}, // removes the "stick"
                    //   dropdownIndicator: (defaultStyles) => ({
                    //     display: "none",
                    //   }),
                    // }}
                  />
                </div>
                <p>{formErrors.siteNames}</p>
              </div>
            </div>

            <div
              id="AddOperator_Form_row2"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddOperator_Name_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_Name"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_Name_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Name*"}
                  </div>
                  <input
                    id="AddOperator_Name_input"
                    type="text"
                    name="username"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.username}
                    onChange={handleChange}
                    maxLength="50"
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.username}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddOperator_Status_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_Status"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_Status_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Status*"}
                  </div>
                  <select
                    id="AddOperator_Status_select"
                    name="isActive"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.isActive}
                    onChange={handleChange}
                    disabled={onlyView || action === "Submit"}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>
                <p>{formErrors.isActive}</p>

                {/* <div className={cn(styles.block3, styles.block3_layout)}>
                  <div
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Last Name"}
                  </div>
                  <input
                    type="text"
                    name="lastName"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.lastName}
                    onChange={handleChange}
                    maxLength="50"
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.lastName}</p> */}
              </div>
            </div>

            <div
              id="AddOperator_Form_row3"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddOperator_PhoneNumber_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_PhoneNumber"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_PhoneNumber_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Phone Number*"}
                  </div>
                  <input
                    id="AddOperator_PhoneNumber_input"
                    type="text"
                    name="phoneNumber"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.phoneNumber}
                    onChange={handleChange}
                    disabled={onlyView}
                    maxLength="10"
                  />
                </div>
                <p>{formErrors.phoneNumber}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddOperator_EmailId_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_EmailId"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_EmailId_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Email Id*"}
                  </div>
                  <input
                    id="AddOperator_EmailId_input"
                    type="emailId"
                    name="emailId"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.emailId}
                    onChange={handleChange}
                    disabled={onlyView || action === "Update"}
                  />
                </div>
                <p>{formErrors.emailId}</p>
              </div>
            </div>

            <div
              id="AddOperator_Form_row4"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddOperator_AddressLine1_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_AddressLine1"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_AddressLine1_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Address Line 1*"}
                  </div>
                  <input
                    id="AddOperator_AddressLine1_input"
                    type="text"
                    name="addressLine1"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.addressLine1}
                    onChange={handleChange}
                    maxLength="250"
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.addressLine1}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddOperator_AddressLine2_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_AddressLine2"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_AddressLine2_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Addres Line 2"}
                  </div>
                  <input
                    id="AddOperator_AddressLine2_input"
                    type="text"
                    name="addressLine2"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.addressLine2}
                    onChange={handleChange}
                    maxLength="250"
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.addressLine2}</p>
              </div>
            </div>

            <div
              id="AddOperator_Form_row5"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddOperator_Country_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_Country"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_Country_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Country*"}
                  </div>
                  <select
                    id="AddOperator_Country_select"
                    name="countryId"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.countryId}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    {/* <option value={formValues.country}></option> */}
                    <option value="-1">Select Country</option>
                    {country.map((data) => {
                      return <option value={data.id}>{data.name}</option>;
                    })}
                  </select>
                  {/* <input
                    type="text"
                    name="country"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.country}
                    onChange={handleChange}
                    disabled={onlyView}
                  /> */}
                </div>
                <p>{formErrors.country}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddOperator_State_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_State"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_State_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"State*"}
                  </div>
                  <select
                    id="AddOperator_State_select"
                    name="stateId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.stateId}
                    onChange={handleChange}
                    disabled={onlyView}
                    required
                  >
                    <option value="-1">Select State</option>
                    {state.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.state}</p>
              </div>
            </div>

            <div
              id="AddOperator_Form_row6"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddOperator_City_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_City"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_City_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"City*"}
                  </div>
                  <select
                    id="AddOperator_City_select"
                    name="cityId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.cityId}
                    onChange={handleChange}
                    disabled={onlyView}
                    required
                  >
                    <option value="-1">Select City</option>
                    {city.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                  {/* <input
                    type="text"
                    name="city"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.city}
                    onChange={handleChange}
                    disabled={onlyView}
                  /> */}
                </div>
                <p>{formErrors.city}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddOperator_ZipCode_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddOperator_ZipCode"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddOperator_ZipCode_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Zip Code*"}
                  </div>
                  <input
                    id="AddOperator_ZipCode_input"
                    type="text"
                    name="zipCode"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.zipCode}
                    onChange={handleChange}
                    disabled={onlyView}
                    maxLength="6"
                  />
                </div>
                <p>{formErrors.zipCode}</p>
              </div>
            </div>

            <div
              id="AddOperator_Button_container"
              className={cn(styles.flex9, styles.flex9_layout)}
            >
              <div
                id="AddOperator_Button_container1"
                className={cn(styles.flex9_item)}
                onClick={reset}
              >
                <div
                  id="AddOperator_BackButton_Background"
                  className={cn(styles.block7, styles.block7_layout)}
                >
                  <h5
                    id="AddOperator_BackButton_title"
                    className={cn(
                      styles.highlights1,
                      styles.highlights1_layout
                    )}
                  >
                    {onlyView ? "Back" : "Cancel"}
                  </h5>
                </div>
              </div>
              <div className={cn(styles.flex9_spacer)} />
              {!onlyView && (
                <div
                  id="AddOperator_SubmitButton"
                  className={cn(styles.flex9_item)}
                  onClick={handleSubmit}
                >
                  <div
                    id="AddOperator_SubmitButton_Background"
                    className={cn(styles.block9, styles.block9_layout)}
                  >
                    <h5
                      id="AddOperator_SubmitButton_title"
                      className={cn(
                        styles.highlights2,
                        styles.highlights2_layout
                      )}
                    >
                      {action}
                    </h5>
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default function AddOperator(props) {
  return (
    <>
      <Master opts={props} screen={AddOperatorForm} showStatus={false} />
    </>
  );
}

AddOperator.inStorybook = true;
